export const styles = {
	avatar: {
		margin: '8px',
		backgroundColor: 'primary.main'
	}
};
